/**
 * AboutValues.tsx — Gold Garage Door / About Us · Section 3/10
 * Navy · 4 value cards asymmetric bento. MOBILE: real <style> media queries.
 * 10WEB AI: keep inline SVG + <style>. Wave dividers intentional — keep.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";

/** clock — DO NOT REPLACE WITH IMG */
const IconClock = () => <svg data-icon-container="lucide-do-not-replace" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>;
/** tag — DO NOT REPLACE WITH IMG */
const IconTag = () => <svg data-icon-container="lucide-do-not-replace" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" /><circle cx="7.5" cy="7.5" r=".5" fill={GOLD} /></svg>;
/** users — DO NOT REPLACE WITH IMG */
const IconUsers = () => <svg data-icon-container="lucide-do-not-replace" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>;
/** shield — DO NOT REPLACE WITH IMG */
const IconShield = () => <svg data-icon-container="lucide-do-not-replace" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" /><path d="m9 12 2 2 4-4" /></svg>;
const VALUES = [{
  icon: <IconClock />,
  title: "On time, every time",
  body: "We give you a real arrival window and we keep it. Your day doesn't revolve around waiting for a tradie who never shows.",
  featured: true
}, {
  icon: <IconTag />,
  title: "Fixed-price honesty",
  body: "The quote is the price. No surprise add-ons, no inflated parts, no 'while we were in there' charges."
}, {
  icon: <IconUsers />,
  title: "Family on the tools",
  body: "The people who answer the phone are the people who turn up. No call centre, no middleman, no excuses."
}, {
  icon: <IconShield />,
  title: "1-Year Labour Warranty",
  body: "Every repair and install is backed by a 1-Year Labour Warranty. If our work fails, we come back and make it right."
}];
export default function AboutValues() {
  return <section id="about-values" style={{
    background: `radial-gradient(ellipse at 20% 100%, #14254d 0%, ${NAVY} 55%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <style>{`
        .av-grid { display: grid; grid-template-columns: 1.4fr 1fr 1fr; grid-template-rows: auto auto; gap: 1.25rem; }
        .av-featured { grid-column: 1 / 2; grid-row: 1 / 3; }
        @media (max-width: 880px) {
          .av-grid { grid-template-columns: 1fr 1fr; }
          .av-featured { grid-column: 1 / 3; grid-row: auto; }
        }
        @media (max-width: 560px) {
          .av-grid { grid-template-columns: 1fr; }
          .av-featured { grid-column: auto; }
          #about-values { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}><filter id="grain-av"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter><rect width="100%" height="100%" filter="url(#grain-av)" /></svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      left: "-1rem",
      top: "8rem",
      fontSize: "11rem",
      fontWeight: 900,
      color: `${GOLD}0D`,
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      lineHeight: 1,
      userSelect: "none",
      pointerEvents: "none"
    }}>03</div>

      <div style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        textAlign: "center",
        maxWidth: "640px",
        margin: "0 auto 3.5rem"
      }}>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD,
          textTransform: "uppercase"
        }}>What We Stand For</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.65rem, 6vw, 2.6rem)",
          color: "#FFFFFF",
          lineHeight: 1.15,
          margin: "0.75rem 0 0.75rem"
        }}>Four things we refuse to compromise on</h2>
          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "1.02rem",
          color: "rgba(255,255,255,0.7)",
          lineHeight: 1.7
        }}>Fifteen years of repeat customers and referrals come down to these.</p>
        </div>

        <div className="av-grid">
          {VALUES.map((v, i) => <div key={i} className={v.featured ? "av-featured" : ""} style={{
          background: v.featured ? `linear-gradient(160deg, ${GOLD}14, rgba(255,255,255,0.03))` : "rgba(255,255,255,0.04)",
          border: `1px solid ${v.featured ? `${GOLD}40` : "rgba(255,255,255,0.1)"}`,
          borderRadius: "16px",
          padding: v.featured ? "2.25rem" : "1.75rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: v.featured ? "space-between" : "flex-start",
          minHeight: v.featured ? "auto" : "180px",
          position: "relative",
          overflow: "hidden"
        }}>
              {v.featured && <div aria-hidden style={{
            position: "absolute",
            right: "-2rem",
            bottom: "-2rem",
            fontSize: "9rem",
            fontWeight: 900,
            color: `${GOLD}0F`,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            lineHeight: 1,
            userSelect: "none"
          }}>GG</div>}
              <div style={{
            width: "52px",
            height: "52px",
            borderRadius: "12px",
            background: `${GOLD}1A`,
            border: `1px solid ${GOLD}33`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "1.25rem",
            position: "relative",
            zIndex: 1
          }}>{v.icon}</div>
              <div style={{
            position: "relative",
            zIndex: 1
          }}>
                <h3 style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: v.featured ? "1.5rem" : "1.15rem",
              color: "#FFFFFF",
              marginBottom: "0.6rem",
              lineHeight: 1.2
            }}>{v.title}</h3>
                <p style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: v.featured ? "1.02rem" : "0.92rem",
              color: "rgba(255,255,255,0.7)",
              lineHeight: 1.65
            }}>{v.body}</p>
              </div>
              {v.featured && <div style={{
            marginTop: "1.5rem",
            position: "relative",
            zIndex: 1
          }}><a href="tel:0485000933" style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              color: GOLD,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700,
              fontSize: "0.95rem",
              textDecoration: "none"
            }}>Book a crew that turns up →</a></div>}
            </div>)}
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>
    </section>;
}